/**
 * Variables
 */
const numberInput = document.getElementById("restockNumber") || false;
const emailInput = document.getElementById("restockEmail") || false;
const form = document.getElementById("restockForm") || false;
const submitBtn = form ? form.querySelector('button[type="submit"]') : false;
const productId = form ? form.querySelector('input[name="productId"]').value : false;

export { numberInput, emailInput, form, submitBtn, productId };

/**
 * Submits the form to the backend
 *
 * @param {String} email
 * @returns {Boolean}
 */
export async function submitForm(email) {
	const formData = new FormData();
	formData.append("restockEmail", email);
	formData.append("productId", productId);
	formData.append("action", "handle_restock_submission");

	const response = await fetch("/wp-admin/admin-ajax.php", {
		method: "POST",
		body: formData,
	});

	if (!response.ok) return false;

	const responseData = await response.json();

	return responseData;
}
